import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Alert, Button, Container, Modal, Table } from '@itds/elements/index.js';

import H1 from '@brokerage/components/H1';

import { Api } from '@brokerage/utils/Api';

const List = () => {
  const navigate = useNavigate();

  const [carriers, setCarriers] = useState([]);
  const [carrier, setCarrier] = useState(null);
  const [error_message, setErrorMessage] = useState(null);
  const [success_message, setSuccessMessage] = useState();
  const [modal, setModal] = useState(false);

  useEffect(() => {
    loadCarriers();
    return () => {
      setErrorMessage(null);
    };
  }, []);

  const loadCarriers = () => {
    Api.loadCarriers().then(response => {
      setCarriers(response.data);
    });
  };

  const handleDelete = (carrier, e) => {
    e.stopPropagation();
    setModal('delete');
    setCarrier(carrier);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    setTimeout(() => {
      setSuccessMessage(null);
      setErrorMessage(null);
    }, 2000);

    Api.deleteCarrier(carrier.id)
      .then(() => {
        setModal(null);
        setCarrier(null);
        loadCarriers();
        setErrorMessage(null);
        loadCarriers();
        setSuccessMessage('Carrier deleted');
      })
      .catch(() => {
        setModal(null);
        setCarrier(null);
        setErrorMessage('Unable to delete Carrier at this time');
      });
  };

  return (
    <Container>
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <H1>Carriers</H1>

        <Button
          onClick={navigate.bind(null, 'new')}
          style={{ marginLeft: 'auto', marginBottom: 30 }}
        >
          Add Carrier
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name',
            width: '100%'
          },
          {
            id: 'actions',
            render: carrier => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, carrier)}
                  small={true}
                >
                  Delete
                </Button>
              );
            }
          }
        ]}
        data={carriers}
        onRowClick={row_object => navigate(`${row_object.id}/general`)}
      />

      {modal === 'delete' ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${carrier.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{carrier.name}"?
          </div>
        </Modal>
      ) : null}
    </Container>
  );
};

List.propTypes = {
  name: PropTypes.string
};

export default List;
